import styled from 'styled-components'
import { BLACK, GRAYSCALE_300, GRAYSCALE_400, NEUTRAL_100, NEUTRAL_300, LIGHT_GRAY_2 } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { getPlatform } from '@lib/telegram'
const isMobile = getPlatform() === 'ios' || getPlatform() === 'mobile'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  border: 1px solid ${NEUTRAL_100};
  padding: 24px 16px 16px 16px;
  border-radius: 16px;
`

export const Label = styled.span`
  font-family: ${INTER.semiBold};
  color: ${NEUTRAL_300};
  font-size: 14px;
  margin-bottom: 2px;
`

export const InputContainer = styled.div`
  position: relative;
`

export const FormInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 8px;
  padding: 14px 6px;
`

export const CountrySelector = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

export const ChevronWrapper = styled.div`
  padding-bottom: 4px;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledInput = styled.input<{ $readOnly?: boolean }>`
  border: none;
  outline: none;
  font-family: ${INTER.regular};
  color: ${BLACK};
  font-size: 16px;
  background: transparent;
  ${props => props.$readOnly && `
    pointer-events: none;
    caret-color: transparent;
  `}
  padding-left: 2px;
  padding-top: ${isMobile ? 5 : 1}px;
`

export const ProviderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ProviderInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const ProviderPlaceholderOuter = styled.div`
  background-color: ${LIGHT_GRAY_2};
  border-radius: 6px;
  padding: 4px;
`

export const ProviderPlaceholderInner = styled.div`
  border-radius: 4px;
  border: 1px dashed ${GRAYSCALE_300};
  padding: 1px 8px;
`

export const ProviderPlaceholder = styled.span`
  font-family: ${INTER.semiBold};
  font-size: 12px;
  color: ${GRAYSCALE_400};
`
